export const name = "HLL_COUNT.MERGE";
export const summary = `Merges HLL++ sketches of the same underlying type into a new sketch, and then gets the cardinality of the new sketch.`;
export const reference = `
## HLL_COUNT.MERGE

Merges HLL++ sketches of the same underlying type into a new sketch, and then gets the cardinality of the new sketch.

\`\`\`
HLL_COUNT.MERGE(sketch)
\`\`\`

### Description

An aggregate function that returns the cardinality of several HLL++ sketches by computing their union.

Each \`sketch\` must be initialized on the same type. Attempts to merge sketches for different types results in an error. For example, you can't merge a sketch initialized from \`INT64\` data with one initialized from \`STRING\` data.

If the merged sketches were initialized with different precisions, the precision will be downgraded to the lowest precision involved in the merge.

This function ignores \`NULL\` values when merging sketches. If the merge happens over zero rows or only over \`NULL\` values, the function returns \`0\`.


### Supported input types

\`BYTES\`


### Return type

\`INT64\`


### Example

The following query counts the number of distinct users across all countries who have at least one invoice.



\`\`\`
SELECT HLL_COUNT.MERGE(hll_sketch) AS distinct_customers_with_open_invoice
FROM
  (
    SELECT
      country,
      HLL_COUNT.INIT(customer_id) AS hll_sketch
    FROM
      UNNEST(
        ARRAY<STRUCT<country STRING, customer_id STRING, invoice_id STRING>>[
          ('UA', 'customer_id_1', 'invoice_id_11'),
          ('BR', 'customer_id_3', 'invoice_id_31'),
          ('CZ', 'customer_id_2', 'invoice_id_22'),
          ('CZ', 'customer_id_2', 'invoice_id_23'),
          ('BR', 'customer_id_3', 'invoice_id_31'),
          ('UA', 'customer_id_2', 'invoice_id_24')])
    GROUP BY country
  );

/*--------------------------------------*
 | distinct_customers_with_open_invoice |
 +--------------------------------------+
 | 3 |
 *--------------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/hll_functions
`;
